<template>
  <section class="hold-transition lockscreen">
    <!-- Automatic element centering -->
    <div class="lockscreen-wrapper">
      <div class="lockscreen-logo">
        <a href="/">{{ CompanyConfig.title_web }}</a>
      </div>
      <!-- User name -->
      <div class="lockscreen-name">Enter your Email</div>

      <!-- START LOCK SCREEN ITEM -->
      <div class="lockscreen-item">
        <!-- lockscreen image -->
        <div class="lockscreen-image">
          <img
            :src=" CompanyConfig.logo_path || '../../static/logo.jpg'"
            alt="User Image"
          >
        </div>
        <!-- /.lockscreen-image -->

        <!-- lockscreen credentials (contains the form) -->
        <form class="lockscreen-credentials" @submit.prevent="sendEmail">
          <div class="input-group">
            <input
              type="Email"
              class="form-control"
              placeholder="Enter Email ..."
            >

            <div class="input-group-append">
              <button
                type="button" @click="sendEmail"
                class="btn"
              ><i class="fas fa-arrow-right text-muted"></i></button>
            </div>
          </div>
        </form>
        <!-- /.lockscreen credentials -->

      </div>
      <!-- /.lockscreen-item -->
      <div class="help-block text-center">
        Enter your email to reset your password
      </div>
      <div class="text-center">
        <a href="/login">Or sign in as a different user</a>
      </div>
      <div class="lockscreen-footer text-center">
        <strong>Copyright &copy; <a href="/">Maeriminterfood Co.,Ltd</a> 2022 </strong><br>
        All rights reserved. <a href="/">Version</a> 1.0.0
      </div>
    </div>
    <!-- /.center -->

  </section>
</template>

<script>
// import api from '../services/service'
export default {
  data () {
    return {
      email: ''
    }
  },
  methods: {
    sendEmail () {
      this.ToDoDev()
      // this.$store.state.isLoading = true
      // api.forgotPassword(
      //   this.$store.state.URLHost,
      //   { email: this.email },
      //   result => {
      //     if (result.response === 'success') {
      //       this.alert_msg(
      //         'success',
      //         'เปลี่ยนรหัสผ่าน',
      //         result.message
      //       )
      //     } else {
      //       this.alert_msg(
      //         'warning',
      //         'เปลี่ยนรหัสผ่าน',
      //         result.message
      //       )
      //     }
      //     this.$store.state.isLoading = false
      //   },
      //   error => {
      //     this.alert_msg(
      //       'error',
      //       'เปลี่ยนรหัสผ่าน',
      //       'ไม่สามารถเปลี่ยนรหัสผ่าน ได้ เนื่องจาก ' + JSON.stringify(error)
      //     )
      //     console.log(JSON.stringify(error))
      //     this.$store.state.isLoading = false
      //   }
      // )
    }
  }
}
</script>

<style>
html,
body {
  background: #e9ecef;
}
</style>



// WEBPACK FOOTER //
// src/views/Forgot_pass.vue